import { Box, Card, CardContent, Typography } from '@mui/material';

interface ICardProps {
   name: string;
   color: string;
   value: string;
 }

export const VCard001: React.FC<ICardProps> = ({ name, color, value }) => {

  return (
    <Box display='flex' >
      <Card sx={{ minWidth: 80, maxHeight:95, backgroundColor: color }}>
        <CardContent>
          <Typography  align="center"  variant="h4"  color="text.secondary" gutterBottom>
            {value || ''}
          </Typography>
          <Typography sx={{ fontSize: 16 }} align="center" component="div">
            {name}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}; 